import { useEffect, useState } from "react";

export function scrollToHeading(id: string) {
  const heading = document.getElementById(id);
  if (!heading) return;
  const nextUrl = `${window.location.pathname}${window.location.search}#${encodeURIComponent(id)}`;
  window.history.replaceState(window.history.state, "", nextUrl);
  heading.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
}

export function useActiveHeading(ids: string[]) {
  const [active, setActive] = useState("");
  const key = ids.join("|");
  useEffect(() => {
    if (!ids.length) { setActive(""); return; }
    let frame = 0;
    const update = () => {
      frame = 0;
      const threshold = window.innerHeight * 0.35;
      let current = "";
      for (const id of ids) {
        const element = document.getElementById(id);
        if (element && element.getBoundingClientRect().top <= threshold) current = id;
      }
      setActive(current);
    };
    const schedule = () => { if (!frame) frame = window.requestAnimationFrame(update); };
    update();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    return () => {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [key]);
  return active;
}
